import FileSize from '../../components/FileSize';
import { Link } from '../../components/Link';
import type { SortableTableColumn } from '../../components/SortableTable';
import { ClassificationCell, ProcessingStatusCells, TagsCell } from '../../components/tableCells';
import type { DocumentRecord } from './documentsTypes';
import { formatDateTime } from '../../lib/dateFormat';

export function getDocumentsTableColumns(showUserColumn: boolean): SortableTableColumn<DocumentRecord>[] {
  return [
    {
      label: 'File Name',
      accessor: 'fileName',
      render: (doc) => (
        <Link
          to={`/documents/${doc.id}`}
          onClick={(e) => e.stopPropagation()}
          className="text-ellipsis overflow-hidden max-w-[250px] inline-block"
          title={doc.fileName}
        >
          {doc.fileName}
        </Link>
      ),
    },
    {
      label: 'Classification',
      accessor: '-',
      render: (doc) => <ClassificationCell category={doc.category} processing={doc.processing} />,
    },
    {
      label: 'Status',
      accessor: 'status',
      render: (doc) => (
        <ProcessingStatusCells
          processing={doc.processing}
          steps={['pages', 'pdfParser', 'metadata', 'embeddings', 'classification', 'reconstruction', 'dataExtraction']}
        />
      ),
    },
    {
      label: 'Tags',
      accessor: 'tags',
      render: (doc) => <TagsCell tags={doc.tags} />,
    },
    {
      label: 'Pages',
      accessor: 'pages',
      // DR-2599/DR-2605: the persisted pageCount scalar replaced the pageIds array, and the
      // deploy-window fallback that read the array went with the phase-1 safety net.
      render: (doc) => doc.processing?.pages?.pageCount,
    },
    {
      label: 'Size',
      accessor: 'size',
      render: (doc) => <FileSize bytes={doc.size} />,
    },
    {
      label: 'User',
      accessor: 'username',
      render: (doc: DocumentRecord) => doc.username,
      enabled: showUserColumn,
    },
    {
      label: 'Created',
      accessor: 'createdAt',
      render: (doc) => formatDateTime(doc.createdAt),
    },
  ];
}
